module.exports = __webpack_public_path__ + "static/media/valve.940730ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DevicesList/valve.png
// module id = 636
// module chunks = 0